export const cart = {
    namespaced: true,
    state: {
        /** 购物车内的课程列表 */
        orderList: [],
    },
    mutations: {
        /** 把课程放入购物车 */
        addCourse(state, data) {
            state.orderList.push(data);
        },
        /** 把课程取出购物车 */
        removeCourse(state, data) {
            state.orderList = state.orderList.filter(
                item => JSON.stringify(item) !== JSON.stringify(data)
            );
        },
        /** 清空购物车 */
        clearCart(state) {
            state.orderList = [];
        }
    },
    getters: {
        /** 计算购物车内课程的总金额 */
        amount: state => {
            return state.orderList.reduce((accumulator, currentValue) => accumulator + currentValue.price, 0);
        }
    }
}
